import React, { Children, ReactNode } from 'react';
import { SwitchButtonsProps } from './interfaces/SwithButtonsProps';

import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { TabPanel } from './TabPanel';

import AppBar from './Tabs.styles';

export default function TabsComponent({ nameTabs, children }: SwitchButtonsProps) {
  const [value, setValue] = React.useState(0);

  const childrenList: Array<ReactNode> = Children.toArray(children);

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue);
  };

  return (
    <>
      <AppBar position="static">
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
          aria-label="scrollable auto tabs example"
        >
          {nameTabs.map((tabs: String, index: number) => {
            return <Tab label={tabs} key={index} />
          })}
        </Tabs>
      </AppBar>

      {childrenList.map((child: ReactNode, index: number) => {
        return (
          <TabPanel key={index} value={value} index={index}>
            {child}
          </TabPanel>
        )
      })}
    </>
  );
}
